/* THE COMFY CLUB — brand interactions */
(function(){
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function ready(fn){ if(document.readyState !== "loading"){ fn(); } else { document.addEventListener("DOMContentLoaded", fn); } }

  ready(function(){

    /* ---------- NAV scroll state ---------- */
    var nav = document.querySelector(".cc-nav");
    if(nav && !nav.classList.contains("cc-nav--page")){
      var onScroll = function(){ if(window.scrollY > 30) nav.classList.add("cc-scrolled"); else nav.classList.remove("cc-scrolled"); };
      onScroll(); window.addEventListener("scroll", onScroll, {passive:true});
    }

    /* ---------- Mobile nav ---------- */
    var navMobile = document.querySelector(".cc-nav__mobile");
    var navToggle = document.querySelector(".cc-nav__toggle");
    if(navMobile && navToggle){
      var navClose = navMobile.querySelector(".cc-m-close");
      var openM = function(){ navMobile.classList.add("cc-open"); navToggle.setAttribute("aria-expanded","true"); navMobile.setAttribute("aria-hidden","false"); document.body.style.overflow="hidden"; };
      var closeM = function(){ navMobile.classList.remove("cc-open"); navToggle.setAttribute("aria-expanded","false"); navMobile.setAttribute("aria-hidden","true"); document.body.style.overflow=""; };
      navToggle.addEventListener("click", openM);
      if(navClose) navClose.addEventListener("click", closeM);
      navMobile.querySelectorAll("a").forEach(function(a){ a.addEventListener("click", closeM); });
      document.addEventListener("keydown", function(e){ if(e.key==="Escape" && navMobile.classList.contains("cc-open")) closeM(); });
    }

    /* ---------- Hero load-in + video ---------- */
    var hero = document.querySelector(".cc-hero");
    if(hero){
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ hero.classList.add("cc-loaded"); }); });
      var v = hero.querySelector("video");
      if(v){
        if(reduce){ v.style.display = "none"; }
        else {
          v.play && v.play().catch(function(){});
          if("IntersectionObserver" in window){
            new IntersectionObserver(function(entries){
              entries.forEach(function(e){ if(e.isIntersecting){ v.play().catch(function(){}); } else { v.pause(); } });
            }, {threshold:0.05}).observe(hero);
          }
        }
      }

      /* ---------- Sparkle canvas ---------- */
      var canvas = hero.querySelector(".cc-hero__spark");
      if(canvas && !reduce){
        var ctx = canvas.getContext("2d");
        var W=0,H=0,dpr=Math.min(window.devicePixelRatio||1,2);
        var particles=[]; var mouse={x:-9999,y:-9999,active:false};
        /* palette: --rose #F48BA3, --bone #FCF4F2, --petal #FFD6DE */
        var ROSE=[244,139,163], BONE=[252,244,242], PETAL=[255,214,222];
        function resize(){
          var r=hero.getBoundingClientRect(); W=r.width; H=r.height;
          canvas.width=W*dpr; canvas.height=H*dpr;
          canvas.style.width=W+"px"; canvas.style.height=H+"px";
          ctx.setTransform(dpr,0,0,dpr,0,0); buildField();
        }
        function buildField(){
          particles=[];
          var count=Math.min(70, Math.round((W*H)/22000));
          for(var i=0;i<count;i++){
            var pick=Math.random(); var col=pick<0.5?ROSE:(pick<0.8?BONE:PETAL);
            particles.push({x:Math.random()*W,y:Math.random()*H,size:Math.random()*2.2+0.8,baseAlpha:Math.random()*0.5+0.15,tw:Math.random()*Math.PI*2,tws:Math.random()*0.03+0.008,vx:(Math.random()-0.5)*0.14,vy:(Math.random()-0.5)*0.14,col:col});
          }
        }
        function drawSpark(p,alpha){
          var s=p.size;
          ctx.save(); ctx.translate(p.x,p.y);
          ctx.fillStyle="rgba("+p.col[0]+","+p.col[1]+","+p.col[2]+","+alpha+")";
          ctx.beginPath();
          ctx.moveTo(0,-s*3); ctx.quadraticCurveTo(0,0,s*3,0);
          ctx.quadraticCurveTo(0,0,0,s*3); ctx.quadraticCurveTo(0,0,-s*3,0);
          ctx.quadraticCurveTo(0,0,0,-s*3); ctx.fill(); ctx.restore();
        }
        function tick(){
          ctx.clearRect(0,0,W,H);
          for(var i=0;i<particles.length;i++){
            var p=particles[i];
            p.x+=p.vx; p.y+=p.vy; p.tw+=p.tws;
            if(p.x<-10)p.x=W+10; if(p.x>W+10)p.x=-10;
            if(p.y<-10)p.y=H+10; if(p.y>H+10)p.y=-10;
            var alpha=p.baseAlpha*(0.55+0.45*Math.sin(p.tw));
            if(mouse.active){
              var dx=p.x-mouse.x, dy=p.y-mouse.y, d=Math.sqrt(dx*dx+dy*dy);
              if(d<150 && d>0.001){ var f=(1-d/150); alpha=Math.min(1,alpha+f*0.75); p.x+=dx/d*f*0.9; p.y+=dy/d*f*0.9; }
            }
            drawSpark(p,alpha);
          }
          requestAnimationFrame(tick);
        }
        hero.addEventListener("pointermove", function(e){ var r=hero.getBoundingClientRect(); mouse.x=e.clientX-r.left; mouse.y=e.clientY-r.top; mouse.active=true; });
        hero.addEventListener("pointerleave", function(){ mouse.active=false; mouse.x=-9999; mouse.y=-9999; });
        window.addEventListener("resize", resize);
        resize(); requestAnimationFrame(tick);
      }
    }

    /* ---------- Scroll reveals ---------- */
    var risers = document.querySelectorAll(".cc-rise");
    if(reduce || !("IntersectionObserver" in window)){
      risers.forEach(function(el){ el.classList.add("cc-in"); });
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(!e.isIntersecting) return;
          io.unobserve(e.target);
          var parent = e.target.parentElement;
          var siblings = parent ? Array.prototype.filter.call(parent.children, function(c){ return c.classList && c.classList.contains("cc-rise"); }) : [e.target];
          var idx = siblings.indexOf(e.target);
          setTimeout(function(){ e.target.classList.add("cc-in"); }, Math.max(0, idx) * 90);
        });
      }, {rootMargin:"0px 0px -8% 0px", threshold:0.05});
      risers.forEach(function(el){ io.observe(el); });
    }

    /* ---------- Count-up stats ---------- */
    var statStrip = document.querySelector(".cc-stats");
    if(statStrip){
      var done=false;
      var run=function(){
        if(done) return; done=true;
        statStrip.querySelectorAll(".cc-stat__num").forEach(function(el){
          var txt=el.getAttribute("data-text");
          if(txt){ el.textContent=txt; return; }
          var target=parseInt(el.getAttribute("data-count"),10)||0;
          var prefix=el.getAttribute("data-prefix")||"";
          var suffix=el.getAttribute("data-suffix")||"";
          var render=function(val){ el.innerHTML=prefix+val+(suffix?'<span class="cc-unit">'+suffix+'</span>':''); };
          if(reduce){ render(target); return; }
          var start=null, dur=1500;
          var step=function(ts){
            if(!start)start=ts;
            var prog=Math.min((ts-start)/dur,1);
            var eased=1-Math.pow(1-prog,4);
            render(Math.round(target*eased));
            if(prog<1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        });
      };
      if("IntersectionObserver" in window){
        new IntersectionObserver(function(en){ en.forEach(function(e){ if(e.isIntersecting) run(); }); },{threshold:0.4}).observe(statStrip);
      } else { run(); }
    }

    /* ---------- Product card tilt ---------- */
    if(!reduce && window.matchMedia("(hover: hover) and (pointer: fine)").matches){
      document.querySelectorAll(".cc-pcard").forEach(function(card){
        var raf=null, tx=0, ty=0;
        var apply=function(){
          raf=null;
          card.style.transform="perspective(900px) rotateX("+(-ty*5)+"deg) rotateY("+(tx*6)+"deg) translateY(-6px)";
        };
        card.addEventListener("pointerenter", function(){ card.style.transition="box-shadow .5s ease"; });
        card.addEventListener("pointermove", function(e){
          var r=card.getBoundingClientRect();
          tx=(e.clientX-r.left)/r.width-0.5;
          ty=(e.clientY-r.top)/r.height-0.5;
          if(!raf) raf=requestAnimationFrame(apply);
        });
        card.addEventListener("pointerleave", function(){
          if(raf){ cancelAnimationFrame(raf); raf=null; }
          card.style.transition="";
          card.style.transform="";
        });
      });
    }

    /* ---------- FAQ accordion ---------- */
    document.querySelectorAll(".cc-faq__item").forEach(function(item){
      var q=item.querySelector(".cc-faq__q");
      var a=item.querySelector(".cc-faq__a");
      if(!q||!a) return;
      q.addEventListener("click", function(){
        var open=item.classList.contains("cc-open");
        document.querySelectorAll(".cc-faq__item.cc-open").forEach(function(o){
          if(o!==item){ o.classList.remove("cc-open"); o.querySelector(".cc-faq__a").style.maxHeight=null; o.querySelector(".cc-faq__q").setAttribute("aria-expanded","false"); }
        });
        if(open){ item.classList.remove("cc-open"); a.style.maxHeight=null; q.setAttribute("aria-expanded","false"); }
        else { item.classList.add("cc-open"); a.style.maxHeight=a.scrollHeight+"px"; q.setAttribute("aria-expanded","true"); }
      });
    });
    window.addEventListener("resize", function(){
      document.querySelectorAll(".cc-faq__item.cc-open .cc-faq__a").forEach(function(a){ a.style.maxHeight=a.scrollHeight+"px"; });
    }, {passive:true});

    /* ---------- Size guide modal (event delegation) ---------- */
    document.addEventListener("click", function(e){
      var openBtn = e.target.closest("[data-cc-sizeguide-open]");
      var modal = document.querySelector("[data-cc-sizeguide]");
      if(openBtn && modal){ e.preventDefault(); modal.hidden=false; document.body.style.overflow="hidden"; return; }
      var closeBtn = e.target.closest("[data-cc-sizeguide-close]");
      if(closeBtn && modal){ modal.hidden=true; document.body.style.overflow=""; }
    });
    document.addEventListener("keydown", function(e){
      var modal = document.querySelector("[data-cc-sizeguide]");
      if(e.key==="Escape" && modal && !modal.hidden){ modal.hidden=true; document.body.style.overflow=""; }
    });

    /* ---------- Waitlist form: client validation ---------- */
    var wform = document.querySelector(".cc-jform");
    if(wform){
      var input = wform.querySelector('input[type="email"]');
      var msg = document.querySelector(".cc-jform__msg");
      var emailRe=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      wform.addEventListener("submit", function(e){
        if(!input) return;
        var val=input.value.trim();
        if(!emailRe.test(val)){
          e.preventDefault();
          input.setAttribute("aria-invalid","true");
          if(msg){ msg.textContent="Please enter a valid email so we can save your spot."; msg.classList.add("cc-err"); }
          input.focus();
        }
      });
      if(input) input.addEventListener("input", function(){
        if(input.getAttribute("aria-invalid")==="true" && emailRe.test(input.value.trim())){
          input.removeAttribute("aria-invalid");
          if(msg){ msg.textContent=""; msg.classList.remove("cc-err"); }
        }
      });
    }

    /* ---------- Smooth anchor scroll ---------- */
    document.querySelectorAll('a[href^="#cc-"], a[href^="/#cc-"]').forEach(function(a){
      a.addEventListener("click", function(e){
        var href=a.getAttribute("href");
        var id=href.replace(/^\//,"");
        if(id.length<2) return;
        var t=document.querySelector(id);
        if(t){ e.preventDefault(); t.scrollIntoView({behavior:reduce?"auto":"smooth", block:"start"}); }
      });
    });

  });
})();
